










import { Vue, Watch } from 'vue-property-decorator'
import Component from 'vue-class-component'
import DeliveryPoint from '@/dto/deliveries/DeliveryPoint'
import PointsTable from '@/components/delivery/delivery-points/PointsTable.vue'
import Delivery from '@/dto/deliveries/Delivery'
import PointForm from '@/components/delivery/delivery-points/PointForm.vue'
import deliveryStore from '@/stores/DeliveryStore'
import deliveryPointsStore from '@/stores/DeliveryPointsStore'
import createDeliveryPointStore from '@/stores/CreateDeliveryPointStore'

@Component({
  components: { PointForm, PointsTable },
})
export default class DeliveryPoints extends Vue {
  deliveryPointsStore = deliveryPointsStore
  createDeliveryPointStore = createDeliveryPointStore
  deliveryStore = deliveryStore
  isPending: boolean = false
  formModel: DeliveryPoint | null = null

  get delivery(): Delivery {
    return this.deliveryStore.delivery as Delivery
  }

  get deliveryPoints(): DeliveryPoint[] {
    return this.deliveryPointsStore.deliveryPoints
  }

  @Watch('delivery', { immediate: true })
  async loadDeliveryPoints() {
    if (!this.delivery) {
      this.deliveryPointsStore.setDeliveryPoints([])
      return
    }

    this.isPending = true
    await this.deliveryPointsStore.loadDeliveryPoints()
    this.isPending = false
  }

  @Watch('deliveryPointsStore.deliveryPoint')
  setModelFromPoint(deliveryPoint: DeliveryPoint) {
    if (deliveryPoint) {
      this.formModel = Object.assign({}, deliveryPoint)
    } else {
      this.formModel = null
    }
  }

  @Watch('createDeliveryPointStore.model')
  setNewModel(deliveryPoint: DeliveryPoint) {
    if (deliveryPoint) {
      this.formModel = deliveryPoint
    } else {
      this.formModel = null
    }
  }

  @Watch('$route', { immediate: true })
  setModel() {
    const { pointId, create } = this.$route.query

    if (this.createDeliveryPointStore.model) {
      this.createDeliveryPointStore.setModel(null)
    }

    if (this.deliveryPointsStore.deliveryPointId) {
      this.deliveryPointsStore.selectDeliveryPoint(null)
    }

    if (pointId) {
      this.deliveryPointsStore.selectDeliveryPoint(parseInt(pointId as string))
    }

    if (create) {
      this.createDeliveryPointStore.setClearModel()
    }

    this.deliveryPointsStore.setErrors({})
  }
}
